import React, { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import ActionButton from "../../common/button/actionbutton.component"
import { NewStockMovementModalProps } from "../../common/types/inventory"
import CustomerSelect from "../../customer/selection.component"
import {
    InventoryStockDocumentAction,
    InventoryStockDocumentDefinitionAction,
    InventoryStockDocumentDefinitionSelector
} from "../../state/inventory"
import { NEW_STOCK_MOVEMENT_MODAL_MESSAGES } from "../../utils/inventory"
import { DocumentTypeSelectComponent, InventoryLocationSelectComponent } from "../components"

export const NewStockMovementModal = injectIntl((props: NewStockMovementModalProps) => {
    const [definitionId, setDefinitionId] = useState(props.definitionId ?? "")
    const [supplierId, setSupplierId] = useState(props.supplierId ?? "")
    const [inventoryLocationId, setInventoryLocationId] = useState("")
    const definitionListing = useSelector(InventoryStockDocumentDefinitionSelector.getListing)
    const apiStatus = useSelector(InventoryStockDocumentDefinitionSelector.getApiStatus)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!apiStatus.isLoaded) {
            dispatch(InventoryStockDocumentDefinitionAction.fetchListing())
        }
    }, [])

    useEffect(() => {
        setSupplierId(props.supplierId ?? "")
    },[definitionId])

    const onClick = () => {
        dispatch(InventoryStockDocumentAction.create({
            inventoryLocationId: inventoryLocationId,
            definitionId: definitionId,
            contactId: supplierId
        }))
    }

    const includeContact = definitionListing.find(item => item.id === definitionId)?.includeContact ?? false
    const validated = definitionId !== "" && !(includeContact && supplierId === "") && inventoryLocationId !== ""
    return (
        <Modal
            className={"custom-modal"}
            show={true}
            onHide={props.onCloseCallback}
            scrollable={true}
            backdrop="static"
            centered={true}
        >
            <Modal.Header closeButton>
                {props.intl.formatMessage(NEW_STOCK_MOVEMENT_MODAL_MESSAGES["header"])}
            </Modal.Header>

            <Modal.Body style={{overflow: "visible"}}>
                <div className="p-3">
                    {!props.definitionId &&
                        <div className={"d-flex justify-content-between align-items-center flex-wrap pb-3"}>
                            <label>
                                {props.intl.formatMessage(NEW_STOCK_MOVEMENT_MODAL_MESSAGES["documentTypeLabel"])}
                            </label>
                            <DocumentTypeSelectComponent
                                className={"col-7"}
                                definitionListing={definitionListing}
                                onChangeCallback={setDefinitionId}
                                selectedValue={definitionId}
                            />
                        </div>
                    }

                    <div className={"d-flex justify-content-between align-items-center flex-wrap pb-3"}>
                        <label>
                            {props.intl.formatMessage(NEW_STOCK_MOVEMENT_MODAL_MESSAGES["locationLabel"])}
                        </label>
                        <InventoryLocationSelectComponent
                            className={"col-7"}
                            selectedValue={inventoryLocationId}
                            onChangeCallback={selected => setInventoryLocationId(selected.value)}
                        />
                    </div>

                    {!props.supplierId && includeContact &&
                        <div className={"d-flex justify-content-between align-items-center flex-wrap pb-3"}>
                            <label>
                                {props.intl.formatMessage(NEW_STOCK_MOVEMENT_MODAL_MESSAGES["contactLabel"])}
                            </label>
                            <CustomerSelect
                                placeholder={NEW_STOCK_MOVEMENT_MODAL_MESSAGES.contactDropdownLabel}
                                contactType={"suppliers"}
                                className={"col-7"}
                                value={supplierId}
                                onChange={setSupplierId}
                            />
                        </div>
                    }
                </div>
            </Modal.Body>

            <Modal.Footer>
                <ActionButton
                    disabled={!validated}
                    className="btn btn-primary"
                    onClick={onClick}
                >
                    {props.intl.formatMessage(NEW_STOCK_MOVEMENT_MODAL_MESSAGES["confirm_btn"])}
                </ActionButton>
            </Modal.Footer>
        </Modal>
    )

})


// WEBPACK FOOTER //
// ./src/inventory/modals/NewStockMovementModal.tsx